module.exports = __webpack_public_path__ + "img/06_tezos-frkusi.f0a48809.jpg";